var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-row',[_c('v-col',{attrs:{"cols":"12","sm":"6","md":"4"}},[_c('v-list',[_c('show-field',{attrs:{"value":_vm.item.name,"label":_vm.$t('delivery.ingredient.labels.name'),"icon":"title"}})],1)],1),_c('v-col',{attrs:{"cols":"12","sm":"6","md":"4"}},[_c('v-list')],1),_c('v-col',{attrs:{"cols":"12","sm":"6","md":"4"}},[_c('v-list')],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }